import { Modal, Button } from "antd";

const LimitationsModal = ({ visible, setVisible, limitations }) => {
  const handleCancel = () => setVisible(false);
  return (
    <Modal
      open={visible}
      title="Limitaciones al dominio"
      onCancel={handleCancel}
      width={1000}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          OK
        </Button>,
      ]}
    >
      <p>El vehiculo presenta las siguientes limitaciones al dominio</p>
      <ul>
        {limitations && limitations.map((l) => <li>{l.toUpperCase()}</li>)}
      </ul>
    </Modal>
  );
};

export default LimitationsModal;
